import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import isSubscribedTo from '@/utils/subscriptionsHelper';
import findResult, { findWithCode } from '@/utils/resultsHelper';
import selectors from '@/selectors';
import callAdapter from '@/utils/sagaHelper';
import DatasetSubscriptionsService from '@/notifications/subscribers/service';
import datasetSubscriptionActions from '../constants';
import { toggleDatasetSubscribeError, toggleDatasetSubscribeSuccess } from '../actions';
import { datasetCategories } from '../../constants';

export function* subscribe({ code, event }) {
  const items = yield select(selectors.datasets);
  const categories = findWithCode(items, datasetCategories, code);
  const item = findResult(items, categories[0], code);
  const { response, error } = isSubscribedTo(item, event)
    ? yield call(callAdapter, DatasetSubscriptionsService.unsubscribe(code, event))
    : yield call(callAdapter, DatasetSubscriptionsService.subscribe(code, event));

  if (error) {
    yield put(toggleDatasetSubscribeError(code, error));
  } else {
    yield put(toggleDatasetSubscribeSuccess(code, response.subscriptions));
  }
}

export default function* datasetSubscriptionsApi() {
  yield takeLatest(datasetSubscriptionActions.TOGGLE_DATASET_SUBSCRIBE, subscribe);
}
